import React, { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  List,
  ListItem,
  ListItemText,
  Dialog,
  Fab,
  Tooltip,
} from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import './EmployeeOffboarding.css';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CircularProgress from '@mui/material/CircularProgress';

import {
  updateEmployeeOffBoardingRequest,
  addOrUpdateEmployeeOffboardingRequest,
  getAllEmployeesOffBoarded,
} from '../../services/EmployeeService';
import EditCard from './EditCard';
import KeycloakService from '../../services/KeycloakService';
import { checkForJobType } from '../../services/EmployeeService';
import { updateEmployeeRole } from '../../admin/Services/MasterdataService';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';
import { getDesignations } from '../../admin/Services/MasterdataService';

const cardStyle = {
  marginTop: '16px',
  position: 'relative',
  marginBottom: '16px',
  cursor: 'default',
  width: '100%',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
};

const cardHeaderStyle = {};

const cardContentStyle = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
};

const employeeImageStyle = {
  width: '100px',
  height: '100px',
};

const listItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
};

const listItemTextStyle = {
  flex: '0 0 50%',
  maxWidth: '50%',
};

const boxStyles = {
  width: '28%',
  textAlign: 'center',
  height: '12rem',
  backgroundColor: 'white',
  position: 'absolute',
  top: '40%',
  left: '40%',
};

// Function to define the common styles for the buttons
const buttonStyles = {
  margin: '7%',
  color: 'white',
  width: '5%',
  height: '19%',
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
};

// Function to define the styles for the modal content
const modalContentStyles = {
  paddingTop: '10%',
};

// Function to handle the No button click and close the modal
const handleNoButtonClick = (setShowModal) => () => {
  setShowModal(false);
};

// Function to handle the Yes button click and perform the action
const handleYesButtonClick = (actionFunction, setShowModal) => () => {
  actionFunction();
  setShowModal(false);
};

// Function to render the modal content with specific details
const renderModalContent = (message, setShowModal, actionFunction) => {
  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <Box style={boxStyles}>
        <Typography sx={modalContentStyles}>{message}</Typography>
        <Button
          style={{ ...buttonStyles, backgroundColor: 'red' }}
          onClick={handleNoButtonClick(setShowModal)}
        >
          No
        </Button>
        <Button
          style={{ ...buttonStyles, backgroundColor: '#4d6cd9' }}
          onClick={handleYesButtonClick(actionFunction, setShowModal)}
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
};

const EmployeeCard = (props) => {
  const {
    isOffboard,
    isAdminOffboard,
    isProfile,
    isAdmin,
    employee,
    EmployeeDetails,
    ShowErrorMessageDob,
    isHr,
    refreshPage,
    ShowErrorMessageDoj,
    ShowErrorMessageOEmail,
    ShowErrorMessagePEmail,
    ShowErrorMessagePhoneNo,
    UpdatedEmployeePhoto,
    ShowErrorMessage,
    Files,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
    designationNames,
  } = props;
  let employee1 = employee;
  const [openModal, setOpenModal] = React.useState(false);
  const [offboardingFormEmployee, setOffboardingFormEmployee] =
    React.useState(employee);
  const [empDetail, setEmpDetail] = React.useState(employee);
  const [isEditable, setIsEditable] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const handleOpen = async () => {
    // This employee may already have a PENDING offboarding request from a
    // previous edit; look it up so the Leaving Date / Expected Leaving Date
    // fields show the previously-saved values instead of re-defaulting to
    // today every time the dialog is reopened.
    let mergedEmployee = employee;
    try {
      const existing = await getAllEmployeesOffBoarded(
        process.env.REACT_APP_TENANT_ID,
        1,
        0,
        '',
        'PENDING',
        employee?.organizationEmailId || employee?.emailId,
      );
      const existingRequest = existing?.data?.data?.content?.[0];
      if (existingRequest) {
        mergedEmployee = {
          ...employee,
          id: existingRequest.id,
          endDate: existingRequest.endDate,
          expectedEndDate: existingRequest.expectedEndDate,
          comments: existingRequest.comments,
          organizationEmailId: existingRequest.organizationEmailId,
        };
      }
    } catch (error) {
      console.error('Failed to look up existing offboarding request:', error);
    }
    setOffboardingFormEmployee(mergedEmployee);
    setOpenModal(true);
  };
  const handleEdit = () => {
    setEmpDetail(employee);
    setIsEditable(true);
  };
  const handleEditClose = () => {
    empDetail.employeeCode = employee.employeeCode;
    empDetail.jobType = employee.jobType;
    empDetail.designation = employee.designation;
    setIsEditable(false);
  };

  var updateEmpDetail;
  const handleSave = async () => {
    setShowModal1(true);
  };

  const confirmSave = async () => {
    setShowModal1(false);
    updateEmpDetail = await updateEmployeeRole(empDetail);

    if (updateEmpDetail.status !== 200) {
      dipatchNotification(updateEmpDetail.type, updateEmpDetail.message);
    }
    if (updateEmpDetail.status === 200) {
      employee.employeeCode = empDetail.employeeCode;
      employee.jobType = empDetail.jobType;
      employee.designation = empDetail.designation;
      setIsEditable(false);
    }
  };
  useEffect(() => {
    setIsEditable(false);
    setEmpDetail(employee);
  }, [refreshPage]);

  var eid;
  const handleJobTypeChange = async (event, value, id) => {
    const { ...newUserDetails } = empDetail;
    setEmpDetail({
      ...newUserDetails,
      jobType: value,
    });

    // Make sure to use 'await' when calling the async function
    const eid = await checkForJobType(value);
    if (value !== employee.jobType) {
      setEmpDetail({
        ...newUserDetails,
        jobType: value,
        employeeCode: eid.data.data,
      });
    }
    if (value == employee.jobType) {
      setEmpDetail({
        ...newUserDetails,
        jobType: value,
        employeeCode: employee.employeeCode,
      });
    }
    // Update the state directly with the new value for 'employeeCode'
  };

  const handleDesignationChange = async (event, value, id) => {
    const { ...newUserDetails } = empDetail;
    setEmpDetail({
      ...newUserDetails,
      designation: value,
    });
  };
  const handleApprove = async () => {
    setLoading(true);
    employee1.status = 'APPROVED';
    const employeeDetail = {
      ...employee1,
      approverId: KeycloakService.getUserDetail(),
    };
    const employeeListByStatus =
      await updateEmployeeOffBoardingRequest(employeeDetail);

    if (employeeListByStatus.status !== 200) {
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      setLoading(false);
      handleToggle(selectedStatus.value);
      return;
    }

    handleToggle(selectedStatus.value);
    setLoading(false);
  };

  const handleReject = async () => {
    setLoading1(true);
    employee1.status = 'REJECTED';
    const employeeDetail = {
      ...employee1,
      approverId: KeycloakService.getUserDetail(),
    };
    const employeeListByStatus =
      await updateEmployeeOffBoardingRequest(employeeDetail);

    if (employeeListByStatus.status !== 200) {
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      setLoading1(false);
      handleToggle(selectedStatus.value);
      return;
    }
    handleToggle(selectedStatus.value);
    setLoading1(false);
  };
  const handleCancel = () => {
    setShowModal(true);
  };
  const confirmClose = async () => {
    setShowModal(false);
    employee1.status = 'CANCELLED';
    const employeeListByStatus =
      await addOrUpdateEmployeeOffboardingRequest(employee1);
    handleToggle(selectedStatus.value);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Card style={cardStyle}>
        <CardHeader
          title={`${employee?.firstName} ${employee?.lastName || ''}`}
          style={cardHeaderStyle}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            paddingLeft: '1.6rem',
          }}
        >
          {(isProfile || isOffboard || isAdminOffboard) ? null : (
            <div>
              <CardMedia
                component="img"
                image={UpdatedEmployeePhoto}
                alt="Employee Photo"
                style={employeeImageStyle}
              />
            </div>
          )}
          <CardContent
            style={{
              ...cardContentStyle,
              display: 'flex',
              justifyContent: 'space-around',
              paddingBottom: 0,
            }}
          >
            <Grid container spacing={2} style={{ padding: 0 }}>
              {(isProfile || isOffboard || isAdminOffboard) ? (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Email"
                        secondary={
                          employee
                            ?(isProfile || isOffboard || isAdminOffboard)
                              ?employee?.organizationEmailId ?employee?.organizationEmailId:employee?.emailId|| ''
                              : employee.organizationEmailId
                            : ''
                        }
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              ) : null}
              <Grid
                item
                xs={6}
                sm={6}
                md={3}
                style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
              >
                <List>
                  <ListItem style={listItemStyle}>
                    <ListItemText
                      primary="Employee ID"
                      secondary={
                        isEditable
                          ? empDetail?.employeeCode
                          : employee?.employeeCode
                      }
                      style={listItemTextStyle}
                    />
                  </ListItem>
                </List>
              </Grid>
              {(isProfile || isOffboard || isAdminOffboard) ? (
                ''
              ) : (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Status"
                        secondary={employee?.status}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              )}
              {isEditable ? (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <InputLabel
                    htmlFor="designation-select"
                    style={{ background: '#fff', color: 'black' }}
                  >
                    Designation
                  </InputLabel>
                  <Select
                    sx={{ width: '100%' }}
                    labelId="designation-select"
                    id="designation-select"
                    value={empDetail?.designation}
                    onChange={(e) =>
                      handleDesignationChange(e, e.target.value, e.target.id)
                    }
                  >
                    {designationNames?.map((designationName, index) => (
                      <MenuItem key={index} value={designationName}>
                        {designationName}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Designation"
                        secondary={employee?.designation}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              )}
              {isEditable && employee?.jobType != 'FULL_TIME' ? (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <InputLabel
                    htmlFor="job-type-select"
                    style={{ background: '#fff', color: 'black' }}
                  >
                    Job Type
                  </InputLabel>
                  <Select
                    sx={{ width: '80%' }}
                    labelId="job-type-select"
                    id="job-type-select"
                    value={empDetail?.jobType}
                    onChange={(e) =>
                      handleJobTypeChange(e, e.target.value, e.target.id)
                    }
                    displayEmpty
                  >
                    <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                    {employee.jobType == 'PART_TIME' ? (
                      <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                    ) : (
                      <MenuItem value="INTERNSHIP">INTERNSHIP</MenuItem>
                    )}
                  </Select>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
                >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Job Type"
                        secondary={
                          employee?.jobType == 'FULL_TIME'
                            ? 'FULL-TIME'
                            : employee?.jobType == 'PART_TIME'
                            ? 'PART-TIME'
                            : employee?.jobType
                        }
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </div>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ width: '100%', height: '10%' }}
        >
          {employee.status !== 'APPROVED' &&
            (isProfile  ? (
              !isEditable ? (
                <Tooltip
                  title={
                    <Typography sx={{ fontSize: '0.8rem' }}>
                      Edit Details
                    </Typography>
                  }
                  placement="top"
                >
                  <Fab
                    color="secondary"
                    size="small"
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '30px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      handleEdit();
                    }}
                  >
                    <EditIcon />
                  </Fab>
                </Tooltip>
              ) : (
                <>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        Cancel{' '}
                      </Typography>
                    }
                    placement="top"
                  >
                    <Fab
                      color="secondary"
                      size="small"
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '100px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleEditClose();
                      }}
                    >
                      <CloseIcon />
                    </Fab>
                  </Tooltip>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        Save Details
                      </Typography>
                    }
                    placement="top"
                  >
                    <Fab
                      color="secondary"
                      size="small"
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '30px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleSave();
                      }}
                    >
                      <SaveIcon />
                    </Fab>
                  </Tooltip>
                </>
              )
            ) : (
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>
                    Edit Details
                  </Typography>
                }
                placement="top"
              >
                <Fab
                  color="secondary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '30px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleOpen();
                  }}
                  disabled={loading || loading1}
                >
                  <EditIcon />
                </Fab>
              </Tooltip>
            ))}
          {!isOffboard && isHr && employee.status !== 'APPROVED' ? (
            <Tooltip title="Cancel">
              <Fab
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '100px',
                  cursor: 'pointer',
                }}
                onClick={handleCancel}
              >
                <CloseIcon style={{ color: 'red', fontSize: '16px' }} />
              </Fab>
            </Tooltip>
          ) : (
            ''
          )}
          {loading ? (
            <Tooltip title="Approve">
              <Fab
                color="primary"
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '100px',
                  cursor: 'pointer',
                }}
              >
                <CircularProgress size={20} color="success" />
              </Fab>
            </Tooltip>
          ) : isAdmin ? (
            employee.status !== 'APPROVED' && (
              <Tooltip title="Approve">
                <Fab
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '100px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleApprove();
                  }}
                  disabled={loading || loading1}
                >
                  <ThumbUpIcon />
                </Fab>
              </Tooltip>
            )
          ) : (
            ''
          )}
          {loading1 ? (
            <Tooltip title="Reject">
              <Fab
                color="secondary"
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '150px',
                  cursor: 'pointer',
                }}
              >
                <CircularProgress size={20} color="warning" />
              </Fab>
            </Tooltip>
          ) : isAdmin ? (
            employee.status !== 'APPROVED' &&
            employee.status !== 'REJECTED' && (
              <Tooltip title="Reject">
                <Fab
                  color="secondary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '150px',
                    cursor: 'pointer',
                  }}
                  onClick={handleReject}
                  disabled={loading || loading1}
                >
                  <ThumbDownIcon />
                </Fab>
              </Tooltip>
            )
          ) : (
            ''
          )}
        </div>
        {(isProfile || isOffboard || isAdminOffboard) ? (
          ''
        ) : (
          <Accordion
            disableGutters
            elevation={0}
            sx={{
              width: '100%',
              '&:before': {
                display: 'none',
              },
            }}
          >
            <Grid
              className="leave-container pb-0 pt-0"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                height: '25px',
                alignItems: 'center',
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon />}
                sx={{ borderTop: 'none', cursor: 'pointer' }}
              />
            </Grid>

            <AccordionDetails>
              <Grid container spacing={13}>
                <Grid item xs={6} sm={6} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Organization Email"
                        secondary={employee?.organizationEmailId}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Phone Number"
                        secondary={employee?.phoneNumber}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Personal Email"
                        secondary={employee?.personalEmailId}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Date of Joining"
                        secondary={employee?.dateOfJoining?.split('T')[0]}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Date of Birth"
                        secondary={employee?.dateOfBirth?.split('T')[0]}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="CountryCode"
                        secondary={employee?.usageLocation}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
      </Card>
      <Dialog open={openModal} fullWidth maxWidth="md" onClose={handleClose}>
        <Card variant="outlined" style={{ marginTop: '-1.2rem' }}>
          <EditCard
            designationNames={designationNames}
            isHr={isHr}
            isAdmin={isAdmin}
            isOffboard={isOffboard}
            handleToggle={handleToggle}
            selectedStatus={selectedStatus}
            allEmployeesDetails={allEmployeesDetails}
            updatedFiles={Files}
            employee={offboardingFormEmployee}
            updatedShowErrorMessage={ShowErrorMessage}
            UpdatedEmployeePhoto={UpdatedEmployeePhoto}
            handleClose={handleClose}
            updatedEmployeeDetails={EmployeeDetails}
            updatedShowErrorMessageDob={ShowErrorMessageDob}
            updatedShowErrorMessageDoj={ShowErrorMessageDoj}
            updatedShowErrorMessageOEmail={ShowErrorMessageOEmail}
            updatedShowErrorMessagePEmail={ShowErrorMessagePEmail}
            updatedShowErrorMessagePhoneNo={ShowErrorMessagePhoneNo}
          />
        </Card>
      </Dialog>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        {renderModalContent(
          'Do you want to Cancel this request?',
          setShowModal,
          confirmClose,
        )}
      </Modal>

      <Modal open={showModal1} onClose={() => setShowModal1(false)}>
        {renderModalContent(
          'Do you want to Save these details?',
          setShowModal1,
          confirmSave,
        )}
      </Modal>
    </>
  );
};

export default EmployeeCard;